class validation {
  public static isBinary = (data: string) => {
    const textThreshold = 0.7;

    const totalChars = data.length;
    let printableChars = 0;

    for (let i = 0; i < totalChars; i++) {
      const charCode = data.charCodeAt(i);
      if (charCode >= 32 && charCode <= 126) {
        printableChars++;
      }
    }

    const percentagePrintable = printableChars / totalChars;

    return percentagePrintable < textThreshold;
  };
}
export default validation;

// const TXTFILE_SIZE_ALLOWED = 330 * 1024; // 330 KB
// const JSONFILE_SIZE_ALLOWED = 83 * 1024; // 83 KB
// const GEOJSONFILE_SIZE_ALLOWED = 5 * 1024 * 1024; // 5 MB
// const SHAPEFILE_SIZE_ALLOWED = 19 * 1024; // 19 KB
// const KMLFILE_SIZE_ALLOWED = 24 * 1024; // 24 KB
// const IMAGE_SIZE_ALLOWED = 3 * 1024 * 1024; // 3 MB

const FILE_SIZE = 5 * 1024 * 1024;

export const validDataSize = (data: string) => {
  const size = new TextEncoder().encode(data).length;
  if (size <= FILE_SIZE) return true;
  return false;
};
export const validFileSize = (file: Blob, format: string) => {
  const size = file.size;
  if (format === "txt") {
    if (size <= FILE_SIZE) return true;
  } else if (format === "zip") {
    if (size <= FILE_SIZE) return true;
  } else if (format === "kmz") {
    if (size <= FILE_SIZE) return true;
  } else if (format === "dwg") {
    if (size <= FILE_SIZE) return true;
  } else if (format === "geojson") {
    if (size <= FILE_SIZE) return true;
  } else if (format === "json") {
    if (size <= FILE_SIZE) return true;
  } else if (format === "image") {
    if (size <= FILE_SIZE) return true;
  }
  return false;
};
